import { combineReducers } from '@reduxjs/toolkit';
import spRatioReducer from './spRatioSlice';

const reducer = combineReducers({
  spRatio: spRatioReducer,
});

export default reducer;
